import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import Img from "../../../images/locationgcc/app-marketing/acquire.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";

const connect = () => {
  return (
    <div className="connect_gcc_web p-100" style={{ background: "#FCFCFC" }}>
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <div className="connect_head">
              <h2>
                Acquire The Right Traction Through Our App Marketing Services in
                Dubai
              </h2>
              <p>
                At TekRevol, we believe in cutting away the conventional agency
                norms by prioritizing a personalized approach. Unlike the
                traditional model, we focus on dedicated attention to ensure
                each client receives tailored strategies and individualized
                care. Our tailored app marketing solutions are designed to
                elevate your app's visibility, engage your target audience, and
                drive impactful results. Let our experts craft strategies that
                align precisely with your goals.
              </p>
              <Link
                to="/contact"
                className="border_btn dark_btn"
                aria-label="TekRevol Contact"
              >
                Connect Now To Get Started
              </Link>
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-xl-1 offset-lg-1"
          >
            <LazyLoadImage
              src={Img}
              effect="blur"
              alt="TekRevol"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default connect;
